module.exports = __webpack_public_path__ + "static/media/state_unknown.c3574c23.svg";